export enum StringConstants {
    BkInvoiceAccountKeyField = "bkInvoiceAccountKey",
    CommissionGroupField = "CommisionGroupId",
    CommissionGroupAll = "NA",
    CommissionGroupAlcro = "A",
    CommissionGroupBeckers = "B",
    CommissionGroupGoodsForResale = "GfR",
    LatestColorShadeStorage = "LatestColorShade",
    MasterItemTypeCodeField = "MasterItemTypeCode",
    ProductActiveStatusValue = "Active",
    ProductDataAreaField = "DataAreaID",
    ProductDiscontinuedStatusValue = "Discontinued",
    ProductReleasedItemLifeCycleAxStatusField = "ReleasedItemLifeCycleAxStatus",
    ProductSharedItemLifeCycleAxStatusField = "SharedItemLifeCycleAxStatus",
    ProductToBeDiscontinuedStatusValue = "To be discontinued",
    SalesArticlesMasterItemTypeCode = "60",
    TintableAXProductDimensionGroupCode = "TintdPaint",
    VisibleInWebShopField = "VisibleInWebShop",
    VisibleInWebShopYes = "YES",
}
